export function requireString(value: string | undefined, name?: string): string {
  if (value === undefined) {
    throw new TypeError(`${name ?? 'Field'} is required.`)
  }
  return value
}
